import React from 'react';

import { SvgIcon } from 'js/app/components/common/SvgIcon';

import { useIsVipLevel } from 'js/app/hooks/auth/hooks/useIsVipLevel';
import { clsx } from 'js/app/utils/clsx.util';
import { useTranslations } from 'js/hooks/i18n';

import style from './GameBands.scss';

export const GameBands = ({ gameData, isDiamondEnabled }) => {
    const isVipLevel = useIsVipLevel();

    const isDiamondVisible = gameData.popular && isDiamondEnabled && isVipLevel;
    const isNewVisible = !isDiamondVisible && gameData.new;
    const isHotVisible = gameData.hot;
    const isExclusiveVisible = !isHotVisible && gameData.exclusive;
    const translate = useTranslations('playtech.mobile.system.gameBands.');

    return (
        <>
            {isDiamondVisible && (
                <span className={clsx(style.band, style.diamondBand)}>
                    <SvgIcon
                        type="diamond"
                        className={style.bandIconDiamond}
                    />
                </span>
            )}

            {isNewVisible && (
                <span className={clsx(style.band, style.newBand)}>
                    {translate('new')}
                </span>
            )}

            {isHotVisible && (
                <span className={clsx(style.band, style.hotBand)}>
                    {translate('club')}
                </span>
            )}

            {isExclusiveVisible && (
                <span className={clsx(style.band, style.exclusiveBand)}>
                    {translate('exclusive')}
                </span>
            )}
        </>
    );
};
